// 테마 엔진 — active theme 토큰을 :root --theme-* 변수에 주입.
// FOUC 방지: 직전 적용 테마(lastKnown)를 첫 페인트 전에 동기 주입.
import api from "./api";

const LS_THEME = "zm_theme_tokens_v1";
const VAR_PREFIX = "--theme-";

// 토큰 객체({ "primary": "#..", "primary-hover": "#.." })를 CSS 변수로 적용.
export function applyThemeTokens(tokens) {
  if (!tokens || typeof tokens !== "object") return;
  const root = document.documentElement;
  Object.entries(tokens).forEach(([k, v]) => {
    if (typeof v === "string" && v) root.style.setProperty(`${VAR_PREFIX}${k}`, v);
  });
}

// 첫 페인트 전 동기 주입(깜빡임 방지). index.js에서 호출.
export function applyLastKnownTheme() {
  try {
    const raw = localStorage.getItem(LS_THEME);
    if (raw) applyThemeTokens(JSON.parse(raw));
  } catch (e) { /* 기본 CSS 변수값(올블루)로 표시 */ }
}

// 서버에서 active theme를 받아 적용 + lastKnown 갱신. 실패 시 현재값 유지(비차단).
export async function fetchAndApplyActiveTheme() {
  try {
    const { data } = await api.get("/theme");
    if (data && data.tokens) {
      applyThemeTokens(data.tokens);
      try { localStorage.setItem(LS_THEME, JSON.stringify(data.tokens)); } catch (e) { /* noop */ }
    }
    return data;
  } catch (e) {
    return null;
  }
}

// 진입/포그라운드 복귀 시 현재 테마 재확인(슬롯 경계·자동 전환 자연 반영).
// lastKnown은 이미 첫 페인트 전 적용돼 깜빡임 없음. 여기선 서버 권위로 갱신만.
let _lastThemeRefresh = 0;
function _throttledRefresh() {
  const now = Date.now();
  if (now - _lastThemeRefresh < 10000) return; // 10s throttle
  _lastThemeRefresh = now;
  fetchAndApplyActiveTheme();
}

let _themeAutoStarted = false;
export function startThemeAutoRefresh() {
  if (_themeAutoStarted || typeof window === "undefined") return;
  _themeAutoStarted = true;
  window.addEventListener("focus", _throttledRefresh);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") _throttledRefresh();
  });
  // Capacitor 네이티브 포그라운드 복귀
  try {
    // eslint-disable-next-line global-require
    const { App: CapApp } = require("@capacitor/app");
    if (CapApp && CapApp.addListener) {
      CapApp.addListener("appStateChange", (state) => {
        if (state && state.isActive) _throttledRefresh();
      });
    }
  } catch (e) { /* 웹에서는 무시 */ }
}
